/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import { ExpandCollapse, Typography } from '@telus-uds/components-web';
import FormSummaryRow from '../formSummaryRow';
import { GroupWrapper, GroupTitle } from '../css';
import {
  BACKEND_KEYS,
  additionalEquipment,
  easyAdditionalEquipment,
  oneTimeAdditionalEquipment,
  fieldWinbackFibre,
  valueNewTelusBusinessOrder,
  fieldWinback,
  fieldAddProductVulcan,
  fieldBusinessConnectVulcan,
  isCouponBasedDiscountField,
  customerAuthorizedValcan
} from '../../utils/constant';

import { getLocalizedStrings, getLocale } from '../../misc';
import { get } from 'lodash';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import CodeBasedPromotions from './components/codeBasedPromotions';
import OfficePhoneLinesTable from '../vulcanHelpers/officePhone/OfficePhoneLinesTable';
import { getSummaryDetailsForFieldWithProductCatalog } from '../vulcanPricing/utils/getFieldSummaryDetails';
import ProductCatalogInternet from './vulcanComponents/productCatalogInternet';
import { getOfferDetailsOfCouppon } from './vulcanComponents/utils';
import { getBusinessOptikTvOrderSummaryRows } from '../vulcanPricing/businessOptikTv/businessOptikTv';

const userDetailsKey = 'userDetails';
const formSectionKey = 'formSection';
const repeatedFormKey = 'repeatedForm';
const formFieldsGroup = 'formFieldsGroup';

const removePrice = label => {
  if (!label || typeof label !== 'string') return label;
  return label.replace(/\([\D\s]*\$[\d.\s\D]*\)/g, '');
};

const priceClean = label => {
  if (Array.isArray(label)) {
    return label.map(filteredLabel => {
      return removePrice(filteredLabel);
    });
  }
  return removePrice(label);
};

export const getFieldLabel = (options, fieldValue) => {
  if (!options || !options.length) {
    if (Array.isArray(fieldValue)) {
      return (
        fieldValue &&
        fieldValue.length > 0 &&
        fieldValue.map(field => priceClean(field))
      );
    }
    return priceClean(fieldValue);
  }
  for (let i = 0; i < options.length; i += 1) {
    const option = options[i];
    const fields = option.fields || {};
    const { label, value } = fields || {};
    if (value === fieldValue) {
      return priceClean(label);
    }
  }

  if (Array.isArray(fieldValue) && fieldValue.length === 0) {
    return null;
  }
  return priceClean(fieldValue);
};

const VulcanOrderSummary = ({ stepData, orderData }) => {
  if (!Array.isArray(stepData)) {
    return null;
  }
  const locale = getLocale();
  const {
    vulcanWebform: {
      businessWifiVul,
      vulBusinessWifi,
      vulFibreInternet,
      vulBusinessConnect,
      vulTSB
    }
  } = locale === 'en-US' ? EN : FR;
  const stepSummaryData = stepData.slice(0, 3);
  const productName = get(orderData, fieldAddProductVulcan, []);
  const orderIdTSBValue = get(orderData, 'orderIdTSB', '');
  const isCouponBasedDiscountValue = get(
    orderData,
    isCouponBasedDiscountField,
    ''
  );
  const isProductVisible = (name, productName) => {
    if (
      (name === 'Fibre Internet ' || name === 'Fibre Internet') &&
      (productName.includes('Internet sur fibre optique') ||
        productName.includes('Internet Fibre') ||
        productName.includes('Fibre Internet'))
    ) {
      return true;
    }

    if (
      name === 'Copper Internet' &&
      (productName.includes('Internet sur cuivre') ||
        productName.includes('Internet sur réseau de cuivre') ||
        productName.includes('Copper Internet'))
    ) {
      return true;
    }

    if (
      name === 'secureBusinessProductVulcan' &&
      (productName.includes('Sécurité d’entreprise de TELUS') ||
        productName.includes('Telus Secure Business')) &&
      !orderIdTSBValue
    ) {
      return true;
    }

    if (
      name === 'Business Wi-Fi' &&
      (productName.includes('Wi-Fi Affaires') ||
        productName.includes('Business Wifi'))
    ) {
      return true;
    }

    if (name === 'customerInformationVulcan') {
      return true;
    }

    if (
      name === 'couponBasedDiscounts' &&
      (isCouponBasedDiscountValue === 'Yes' ||
        isCouponBasedDiscountValue === 'Oui')
    ) {
      return true;
    }

    if (
      name === 'businessOptikTvVulcan' &&
      (productName.includes('Business Optik TV') ||
        productName.includes('Business Optik TV'))
    ) {
      return true;
    }

    if (
      name === 'officePhoneVulcan' &&
      (productName.includes('Office Phone') ||
        productName.includes('Téléphone de bureau'))
    ) {
      return true;
    }

    if (
      name === 'businessInternetBackup' &&
      (productName.includes('TELUS Internet Backup') ||
        productName.includes('Internet de secours TELUS'))
    ) {
      return true;
    }

    return false;
  };

  const isSectionVisisble = stepBackendKey => {
    if (
      stepBackendKey === ' additionalCustomerInformation' &&
      (productName.includes(vulBusinessConnect) || orderIdTSBValue)
    ) {
      return false;
    }
    return true;
  };
  const {
    contentfulValues: { yes, no }
  } = getLocalizedStrings();

  // Function to handle boolean values
  const handleBooleanValue = value => {
    return value ? yes : no;
  };

  // Function to handle field values
  const handleFieldValue = (backendKey, value) => {
    if (typeof value === 'boolean') {
      return handleBooleanValue(value);
    }
    return value;
  };

  const groupSummary = (
    fieldNamesArray,
    formStepFieldsArray,
    groupOrderData
  ) => {
    return formStepFieldsArray.map((formStepFields, index) => {
      if (!formStepFields) return null;
      const nonEmptyFields =
        formStepFields &&
        formStepFields.filter(currentField => {
          const {
            fields: { backendKey }
          } = currentField || {};
          const isObject = typeof groupOrderData[backendKey] === 'object';
          const isArray = Array.isArray(groupOrderData[backendKey]);
          if (isObject && !isArray) {
            return !!groupOrderData[backendKey].value;
          }
          if (isArray && groupOrderData[backendKey].length) {
            return true;
          }
          return !!groupOrderData[backendKey];
        });

      if (!nonEmptyFields || !nonEmptyFields.length) return null;
      const setTitle = label => {
        if (label === additionalEquipment) {
          return `${label} (${oneTimeAdditionalEquipment})`;
        }
        if (label === easyAdditionalEquipment) {
          return `${additionalEquipment} (${label})`;
        }
        return label;
      };
      return (
        <GroupWrapper
          key={index}
          style={{ marginBottom: '1em', paddingLeft: 0, paddingRight: 0 }}
        >
          <GroupTitle style={{ marginBottom: '0.5em' }}>
            {setTitle(fieldNamesArray[index])}
          </GroupTitle>
          {nonEmptyFields &&
            nonEmptyFields.map(({ fields: { backendKey, label, options } }) => {
              let fieldValue = '';
              const isArray = Array.isArray(groupOrderData[backendKey]);
              const isObject = typeof groupOrderData[backendKey] === 'object';
              if (isObject && !isArray) {
                fieldValue = priceClean(groupOrderData[backendKey].value);
              } else if (isArray) {
                fieldValue = groupOrderData[backendKey]
                  .join(', ')
                  .split(',')
                  .map(item => priceClean(item))
                  .join(',');
              } else {
                fieldValue = priceClean(groupOrderData[backendKey]);
              }
              fieldValue = handleFieldValue(backendKey, fieldValue);
              const labelLogic =
                fieldNamesArray[index] &&
                fieldNamesArray[index] === additionalEquipment
                  ? priceClean(label)
                  : priceClean(label);
              return (
                <FormSummaryRow
                  key={backendKey}
                  label={labelLogic}
                  value={getFieldLabel(options, fieldValue)}
                  isDollarRemove
                />
              );
            })}
        </GroupWrapper>
      );
    });
  };

  const handleFormSummaryRow = (
    {
      fieldLabel,
      fieldBackendKey,
      fieldName,
      formStepFields,
      contentfulId,
      formTitle,
      options: mainOptions,
      appearsAfterValue,
      appearsAfterField,
      easyPaymentFields,
      easyPaymentTitle
    },
    customOrderData
  ) => {
    const dataOrder = customOrderData || orderData;

    if (
      (fieldName === fieldWinbackFibre || fieldName === fieldWinback) &&
      dataOrder.orderType !== valueNewTelusBusinessOrder
    )
      return null;
    if (contentfulId === userDetailsKey) {
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }
    if (contentfulId === formFieldsGroup) {
      return groupSummary([fieldName], [formStepFields], dataOrder);
    }
    if (contentfulId === formSectionKey) {
      return (
        formStepFields &&
        formStepFields.length > 0 &&
        formStepFields.map(item => {
          const {
            fields: {
              label,
              backendKey,
              name: sectionFieldName,
              fields: groupFields,
              formFields: sectionFormFields,
              title,
              formTitle: sectionFormTitle,
              appearsAfterField: sectionAppearsAfterField,
              appearsAfterValue: sectionAppearsAfterValue
            },
            sys: {
              contentType: {
                sys: { id: fieldContentfulId }
              }
            }
          } = item || {};
          const rowObj = {
            fieldLabel: label,
            fieldBackendKey: backendKey,
            fieldName: sectionFieldName || title,
            formStepFields: groupFields || sectionFormFields,
            contentfulId: fieldContentfulId,
            formTitle: title || sectionFormTitle,
            appearsAfterField: sectionAppearsAfterField,
            appearsAfterValue: sectionAppearsAfterValue
          };
          return handleFormSummaryRow(rowObj, customOrderData);
        })
      );
    }
    if (contentfulId === repeatedFormKey) {
      return (
        dataOrder[fieldName] &&
        dataOrder[fieldName].map((row, idx) =>
          groupSummary([`${formTitle} ${idx + 1}`], [formStepFields], row)
        )
      );
    }
    if (fieldName === 'OptikTvTable') {
      const transformedData = getBusinessOptikTvOrderSummaryRows(
        dataOrder.OptikTvTable,
        dataOrder
      );
      return (
        <GroupWrapper
          style={{ marginBottom: '1em', paddingLeft: 0, paddingRight: 0 }}
        >
          {transformedData.map((row, index) => (
            <FormSummaryRow key={index} label={row.label} value={row.value} />
          ))}
        </GroupWrapper>
      );
    }

    if (fieldName === 'fibreConsolidation') {
      return <ProductCatalogInternet tableData={orderData.fibreInternetData} />;
    }

    if (fieldName === 'copperConsolidation') {
      return (
        <ProductCatalogInternet tableData={orderData.copperInternetData} />
      );
    }

    if (fieldName === 'addLineOfficePhoneVulcan') {
      // `officePhoneLinesData` is the fallback for orders saved before the
      // dual-write fix (vulcanSectionRegistry.js's OfficePhoneSection) started
      // also writing this field's own name — those orders only ever
      // persisted the ancillary key.
      return (
        <OfficePhoneLinesTable
          officePhoneLinesData={
            dataOrder.addLineOfficePhoneVulcan || dataOrder.officePhoneLinesData
          }
          isSummary={true}
        />
      );
    }
    // The saved checkbox value outlives its visibility; hide it unless the controlling answer still matches.
    if (
      fieldBackendKey === customerAuthorizedValcan &&
      appearsAfterField &&
      appearsAfterField.length
    ) {
      const allowedValues = (appearsAfterValue || []).map(v => v.fields.value);
      const isAppearing = appearsAfterField.every(related => {
        const { backendKey, name } = related.fields;
        return (
          !allowedValues.length ||
          allowedValues.includes(dataOrder[backendKey || name])
        );
      });
      if (!isAppearing) return null;
    }
    const fieldKey =
      (dataOrder[fieldBackendKey] && fieldBackendKey) || fieldName;
    let fieldValue = getFieldLabel(mainOptions, dataOrder[fieldKey]);

    // Check if the type can be converted to float
    let typeCheckedFieldValue = parseFloat(fieldValue);

    // Check if the value really is in decimals and needs rounding off
    if (typeCheckedFieldValue && typeCheckedFieldValue % 1 !== 0) {
      typeCheckedFieldValue = typeCheckedFieldValue.toFixed(2);
    } else if (typeof fieldValue === 'boolean') {
      typeCheckedFieldValue = handleBooleanValue(fieldValue);
    } else {
      typeCheckedFieldValue = fieldValue;
    }

    if (fieldName === 'secureBusinessOffersVulcan') {
      const baseValue =
        typeCheckedFieldValue === null
          ? []
          : Array.isArray(typeCheckedFieldValue)
          ? typeCheckedFieldValue
          : [typeCheckedFieldValue];
      typeCheckedFieldValue = [
        ...baseValue,
        ...getOfferDetailsOfCouppon(orderData.tsbData)
      ];
    }

    return (
      <FormSummaryRow
        key={fieldBackendKey}
        label={fieldLabel}
        value={typeCheckedFieldValue}
        isDollarRemove
      />
    );
  };

  const rowCb = (formStepFields, customOrderData) => {
    return formStepFields.map(formStepField => {
      const {
        fields: {
          label: fieldLabel,
          outputLabel,
          backendKey: fieldBackendKey,
          formStepFields: subStepFields,
          easyPaymentFields,
          easyPaymentTitle,
          formFields: repeatedGroupFields,
          appearsAfterField,
          appearsAfterValue,
          fields: groupFields,
          name: fieldName,
          title: groupTitle,
          formTitle,
          options
        },
        sys: {
          contentType: {
            sys: { id: contentfulId }
          }
        }
      } = formStepField;
      const isValidRow = contentfulId !== 'equipmentGroupSection';
      return (
        <React.Fragment key={fieldBackendKey}>
          {isValidRow &&
            handleFormSummaryRow(
              {
                fieldLabel: outputLabel || fieldLabel,
                fieldBackendKey,
                formStepFields:
                  subStepFields ||
                  repeatedGroupFields ||
                  groupFields ||
                  formStepFields,
                fieldName: fieldName || groupTitle,
                contentfulId,
                formTitle: formTitle || groupTitle,
                options,
                appearsAfterField,
                appearsAfterValue,
                easyPaymentFields,
                easyPaymentTitle
              },
              customOrderData,
              formStepFields
            )}
        </React.Fragment>
      );
    });
  };

  const handelQuotePage = (formStepFields, expandProps) => {
    return formStepFields.map(
      ({ fields: { title, name, formFields } }) =>
        [
          'customerInformationVulcan',
          ...(orderData.orderId && orderData.orderId.includes('VUL')
            ? ['Fibre Internet']
            : ['Fibre Internet ']),
          'Copper Internet',
          'Business Wi-Fi',
          'secureBusinessProductVulcan',
          'couponBasedDiscounts',
          'businessOptikTvVulcan',
          'officePhoneVulcan',
          'businessInternetBackup'
        ].includes(name) &&
        isProductVisible(name, productName) &&
        (name === 'couponBasedDiscounts' ? (
          <ExpandCollapse.Panel
            {...expandProps}
            panelId={name}
            control={<Typography variant={{ size: 'h2' }}>{title}</Typography>}
            key={name}
          >
            <CodeBasedPromotions orderData={orderData} />
          </ExpandCollapse.Panel>
        ) : (
          <ExpandCollapse.Panel
            {...expandProps}
            panelId={name}
            control={<Typography variant={{ size: 'h2' }}>{title}</Typography>}
            key={name}
          >
            {formFields && rowCb(formFields)}
          </ExpandCollapse.Panel>
        ))
    );
  };

  return (
    <>
      <ExpandCollapse>
        {expandProps => (
          <>
            {stepSummaryData &&
              stepSummaryData.map(
                ({
                  fields: {
                    name: stepName,
                    backendKey: stepBackendKey,
                    formStepFields
                  }
                }) =>
                  stepBackendKey !== 'quoteVulcan'
                    ? isSectionVisisble(stepBackendKey) && (
                        <ExpandCollapse.Panel
                          {...expandProps}
                          panelId={stepBackendKey}
                          control={
                            <Typography variant={{ size: 'h2' }}>
                              {stepName}
                            </Typography>
                          }
                          key={stepBackendKey}
                        >
                          {rowCb(formStepFields[0].fields.formFields)}
                        </ExpandCollapse.Panel>
                      )
                    : handelQuotePage(formStepFields, expandProps)
              )}
          </>
        )}
      </ExpandCollapse>
    </>
  );
};

VulcanOrderSummary.propTypes = {
  stepData: PropTypes.objectOf(PropTypes.any).isRequired,
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  isQuestionVisible: PropTypes.bool.isRequired
};

export default VulcanOrderSummary;
